import Vue from 'vue';

Vue.component('corporate-tax-models-component', {
    props: {
        models: {
            type: Array,
            required: true,
        },
        mappedModelNames: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            selectedModel: null,
        };
    },
    mounted() {
        this.selectedModel = this.models?.[0];
    },
    methods: {
        parseTransformedImage(image) {
            return JSON.parse(image);
        },

        selectModel(model) {
            this.selectedModel = model;

            const modelButton = document.getElementById(`${model}-selector`);

            if (modelButton && window.innerWidth < 768) {
                modelButton.scrollIntoView({
                    behavior: 'smooth',
                });
            }
        },

        isModelSelected(model) {
            return this.selectedModel === model;
        },
    },
});
